import { createSlice } from '@reduxjs/toolkit';

const modelListSlice = createSlice({
  name: 'modelList',
  initialState: {
    entity: {
      models: [],
      totalRecords: 0,
    },
    devices: [],
  },
  reducers: {
    storeModels: (state, action) => {
      state.entity = action.payload;
    },
    storeUserDevices: (state, action) => {
      const { data, mode } = action.payload;
      if (mode) {
        state.devices = [];
      }
      state.devices.push(...data);
    },
  },
});

const {
  reducer: modelListReducer,
  actions: { storeModels, storeUserDevices },
} = modelListSlice;

export { modelListReducer, storeModels, storeUserDevices };
